import React from 'react'

export default function Loader() {
  return (
    <div className="loader-overlay">
      <i className="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
    </div>
  )
}
